module.exports = __webpack_public_path__ + "static/img/imgs2.c244b83b.jpg";